import { HistoryEdu, QuestionAnswerOutlined, ArchiveOutlined, LocalPharmacyOutlined, LocalHospitalOutlined, EmergencyOutlined } from '@mui/icons-material';
import { Elderly } from '@mui/icons-material';
import Stethoscope from "Images/stethoscope.svg"
import { Image } from 'react-bootstrap';
import { PATHS } from 'Utils/PagePaths';

/**Top Navigation const */
export const TOP_NAV_ITEMS = [
  {
    type: "listItem",
    title: "Become a PSO",
    link: PATHS.public['Become a PSO'],
    hidden: (e) => {
      if (e == true) {
        return true;
      }
      else {
        return false;
      }
    }
  },
  {
    type: "subMenu",
    title: "Use Common Formats",
    id: "ahrqCommonFormatsMenu",
    items: {
      col1: [
        { link: PATHS.public['Use Common Formats'], title: "Current Common Formats", desc: "Learn more on the AHRQ Common Formats", icon: () => <HistoryEdu ></HistoryEdu> },
        { link: PATHS.public['Provide Feedback'], title: "Provide Feedback", desc: "Provide feedback on Common Formats Event", icon: () => <QuestionAnswerOutlined ></QuestionAnswerOutlined> },
        { link: PATHS.public['Retired Common Formats'], title: "Retired Common Formats", desc: "Retired AHRQ Common Formats", icon: () => <ArchiveOutlined ></ArchiveOutlined> }
      ],
      col2: [
        {
          link: PATHS.public['Surveillance - Hospital'], title: "Surveillance - Hospital", desc: "Version 1.0", icon: () => <EmergencyOutlined></EmergencyOutlined>
        },
        { link: PATHS.public['Diagnostic Safety'], title: "Diagnostic Safety", desc: "Version 1.0", icon: () => <Image alt="Stethoscope" src={Stethoscope}></Image> },
        { link: PATHS.public['Nursing Home'], title: "Nursing Home", desc: "Version 1.0", icon: () => <Elderly></Elderly> },
        { link: PATHS.public['Hospital Version 2.0'], title: "Hospital", desc: "Version 2.0", icon: () => <LocalHospitalOutlined ></LocalHospitalOutlined> },
        { link: PATHS.public['Community Pharmacy'], title: "Community Pharmacy", desc: "Version 1.0", icon: () => <LocalPharmacyOutlined ></LocalPharmacyOutlined> },
        // example of using download svg if MUI Icon could not meet requirements
        { link: PATHS.public['Hospital Version 1.2'], title: "Hospital", desc: "Version 1.2", icon: () => <LocalHospitalOutlined ></LocalHospitalOutlined> }
      ]
    }
  },
  {
    type: "listItem",
    title: "Submit Data",
    link: PATHS.public['Submit Data']
  },
  {
    type: "listItem",
    title: "Learn from the Data",
    link: PATHS.public['Learn from the Data']
  },
  {
    type: "listItem",
    title: "Data Security",
    link: PATHS.public['Data Security']
  }
];

export const TOP_NAV_ITEMS_AS_LEFT_NAV = [
  {
    type: "listItem",
    menuName1: "Become a PSO",
    menuLink: PATHS.public['Become a PSO'],
  },
  {
    type: "subMenu",
    title: "Use Common Formats",
    subList: [
      {
        menuLink: PATHS.public['Use Common Formats'],
        menuName1: "Use Common Formats",
        menuName2: "Current Common Formats"
      },
      /* comment out feedback for UAT: TODO:!!! revert for commenting tool development*/
      {
        menuLink: PATHS.public['Provide Feedback'],
        menuName1: "Use Common Formats",
        menuName2: "Provide Feedback"
      },
      
      {
        menuLink: PATHS.public['Retired Common Formats'],
        menuName1: "Use Common Formats",
        menuName2: "Retired Common Formats"
      },
      {
        menuLink: PATHS.public['Surveillance - Hospital'],
        menuName1: "Use Common Formats",
        menuName2: "Surveillance - Hospital Version 1.0"
      },
      {
        menuLink: PATHS.public['Diagnostic Safety'],
        menuName1: "Use Common Formats",
        menuName2: "Diagnostic Safety"
      },
      {
        menuLink: PATHS.public['Nursing Home'],
        menuName1: "Use Common Formats",
        menuName2: "Nursing Home Version 1.0"
      },
      {
        menuLink: PATHS.public['Hospital Version 2.0'],
        menuName1: "Use Common Formats",
        menuName2: "Hospital Version 2.0"
      },
      {
        menuLink: PATHS.public['Community Pharmacy'],
        menuName1: "Use Common Formats",
        menuName2: "Community Pharmacy"
      },
      {
        menuLink: PATHS.public['Hospital Version 1.2'],
        menuName1: "Use Common Formats",
        menuName2: "Hospital Version 1.2"
      }
    ]
  },
  {
    type: "listItem",
    menuName1: "Submit Data",
    menuLink: PATHS.public['Submit Data'],
  },
  {
    type: "listItem",
    menuName1: "Learn from the Data",
    menuLink: PATHS.public['Learn from the Data'],
  },
  {
    type: "listItem",
    menuName1: "Data Security",
    menuLink: PATHS.public['Data Security']
  }
];

export const USER_PROFILE_ITEMS_AS_LEFT_NAV = [
  {
    type: "subMenu",
    title: "Account Settings",
    subList: [
      {
        menuLink: PATHS.private["editUserProfile"],
        menuName1: "My Profile",
        menuName2: "My Profile"
      },
      {
        menuLink: PATHS.private["resetUserPassword"],
        menuName1: "My Profile",
        menuName2: "Reset Password"
      },
      {
        menuLink: PATHS.private["setupMfa"],
        menuName1: "My Profile",
        menuName2: "Two-Factor Authentication"
      },
    ]
  }
  /* comment out for MVP release
  {
    type: "listItem",
    menuName1: "Notifications",
    menuLink: "/publicpages/notifications"
  } */
];

export const HELP_ABOUT_AS_LEFT_NAV = [
  {
    type: "listItem",
    menuName1: "Get Help",
    menuLink: PATHS.public["Get Help"]
  },
  {
    type: "listItem",
    menuName1: "About PSOPPC",
    menuLink: PATHS.public["About PSOPPC"]
  }
];